import React from "react";

export default function Footer({ space }) {
  return (
    <>
      <footer className="footer-section">
        <div
          className={`footer-top background-img-2 ${
            space ? "pt-150" : "pt-60"
          }`}
          style={{
            background:
              "url('assets/img/a_comunes/footer-bg-upgrade.jpg') no-repeat center top / cover",
          }}
        >
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-12 col-lg-4 mb-4 mb-md-4 mb-sm-4 mb-lg-0">
                <div className="footer-nav-wrap text-white">
                  <img
                    src="assets/img/logo-white-1x.png"
                    alt="footer logo"
                    width="120"
                    className="img-fluid mb-3"
                  />
                  <p>
                    Creamos experiencias únicas para estudiantes con aventuras
                    que te van a volar la cabeza y fiestas que no vas a olvidar.
                  </p>{" "}
                  <p> Lo hacemos único.</p>
                  <div className="social-list-wrap">
                    <ul className="social-list list-inline list-unstyled">
                      <li className="list-inline-item">
                        <div
                          style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "center",
                          }}
                        >
                          <li className="list-inline-item">
                            <a
                              href="https://www.instagram.com/upgradeoficial/"
                              target="_blank"
                              without
                              rel="noreferrer"
                              title="Instagram"
                            >
                              <span className="ti-instagram"></span>
                            </a>
                          </li>
                          <li className="list-inline-item">
                            <a
                              href="https://www.facebook.com/upgradeoficial/"
                              target="_blank"
                              without
                              rel="noreferrer"
                              title="Facebook"
                            >
                              <span className="ti-facebook"></span>
                            </a>
                          </li>
                          <li className="list-inline-item"
                           style={{marginTop: '4px'}}
                           >
                            <a
                              href="https://www.tiktok.com/@upgradeoficial?_t=8pHHRhlozqw&_r=1"
                              target="_blank"
                              rel="noreferrer"
                              title="TikTok"
                            >
                              <img src="assets/icons/tik-tok.png" width={22} height={22} />
                            </a>
                          </li>
                        </div>
                      </li>
                      {/* <li className="list-inline-item">
                        <a href="#/" target="_blank" title="Twitter">
                          <span className="ti-twitter"></span>
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-8">
                <div className="row">
                  <div className="col-sm-6 col-md-4 col-lg-4 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                    <div className="footer-nav-wrap text-white">
                      <h5 className="mb-3 text-white">Recursos</h5>
                      <ul className="list-unstyled">
                        {/* <li className="mb-2">
                          <a href="#/">Oficinas</a>
                        </li>
                        <li className="mb-2">
                          <a href="#/">Preguntas Frecuentes</a>
                        </li> */}
                        <li className="mb-2">
                          <a href="https://www.paxmanager.com.ar/upgrade/">
                            Asistencia al pasajero
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                    <div className="footer-nav-wrap text-white">
                      <h5 className="mb-3 text-white">Destinos</h5>
                      <ul className="list-unstyled support-list">
                        <li className="mb-2">
                          <a href="/primarios">Primarios</a>
                        </li>
                        <li className="mb-2">
                          <a href="/secundarios">Secundarios</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4">
                    <div className="footer-nav-wrap text-white">
                      <h5 className="mb-3 text-white">Location</h5>
                      <ul className="list-unstyled support-list">
                        <li className="mb-2 d-flex align-items-center">
                          <span className="ti-location-pin mr-2"></span>
                          TUCUMAN 612, PISO 6, CABA
                          <br />
                          C.A.B.A. (C1049AAN)
                        </li>
                        <li className="mb-2 d-flex align-items-center">
                          <span className="ti-mobile mr-2"></span>
                          <a href="https://wa.me/+5491126680675" class="contact__subtitle">+54 (911) 2668-0675</a>
                        </li>
                        <li className="mb-2 d-flex align-items-center">
                          <span className="ti-email mr-2"></span>
                          <a href="mailto:INFO@UPGRADETURISMO.COM.AR">
                            {" "}
                            info@upgradeturismo.com.ar
                          </a>
                        </li>
                        <li className="mb-2 d-flex align-items-center">
                          <span className="ti-world mr-2"></span>
                          <a href="https://www.upgradeturismo.com.ar/">
                            upgradeturismo.com.ar
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom border-gray-light mt-5 py-3">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-7">
                  <div className="copyright-wrap small-text">
                    <p className="mb-0 text-white">
                      ©UpgradeTurismo, Todos los derechos reservados
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-5">
                  <div className="terms-policy-wrap text-lg-right text-md-right text-left">
                    <ul className="list-inline">
                      <li className="list-inline-item">
                        {/* <a className="small-text" href="#/">
                          Politica de Seguridad
                        </a> */}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
